    // 方案类型
    const TYPES = {
        geographyBulletin: "地理国情公报",
        naturalResources: "自然资源状况",
      }
    export { TYPES }